
import React from 'react';
import { Button } from "@/components/ui/button";
import { Loader2, Check } from "lucide-react";
import { DialogFooter } from "@/components/ui/dialog";

interface GameFormActionsProps {
  isUploading: boolean;
  isEditMode: boolean;
  onCancel: () => void;
}

export const GameFormActions: React.FC<GameFormActionsProps> = ({
  isUploading,
  isEditMode,
  onCancel
}) => {
  return (
    <DialogFooter>
      <Button
        type="button"
        variant="outline"
        onClick={onCancel}
        className="bg-[#242C37] hover:bg-[#1E293B] text-white border-[#2A3749]"
        disabled={isUploading}
      >
        Cancelar
      </Button>
      <Button 
        type="submit" 
        className="bg-gradient-to-r from-[#00B6F0] to-[#43acdc] hover:from-[#0095cc] hover:to-[#318db0] text-white"
        disabled={isUploading}
      >
        {isUploading ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" /> 
            {isEditMode ? "Atualizando..." : "Adicionando..."}
          </>
        ) : (
          <>
            <Check className="mr-2 h-4 w-4" />
            {isEditMode ? "Atualizar" : "Adicionar"}
          </>
        )}
      </Button>
    </DialogFooter>
  );
};
